import { View, Text, Pressable, Image, ScrollView, Linking } from 'react-native'
import React, { useLayoutEffect } from 'react'
import { useNavigation } from '@react-navigation/native'
import AsyncStorage from '@react-native-async-storage/async-storage';
import { useState } from "react";
import alert from './../alert';
import GlobalStyles from './../style';
import ttptr from './../teamsThatPlayThisRound';
import dr from './../datosReferenciales.json';
import checkLesiones from '../checkLesiones';
import transl from './../translations/transl'
import { useSelector } from 'react-redux';
import { useEffect } from 'react';
import { useCallback } from 'react';
import VersionNumber from 'react-native-version-number';
import globalInfo from '../globalInfo';

let nextGameInfo = {}
let lang = undefined;
let urlUpdateOpened = false;

const HomeScreen = () => {
  const navigation = useNavigation();

    useLayoutEffect(() => {
        navigation.setOptions({
          //headerShown: false,
          headerTitle: transl('HomeScreen.menuPrincipal',lang)
        })
    }, []);

    const language = useSelector((state) => state.language);
    lang = dr.idiomas[language ? language : 0].value

    //receivedData
    const [value, setvalue] = useState('');
    const readValue = () => {
      AsyncStorage.getItem('equipos')
      .then((value)=> {
        setvalue(value)
        if(!value || value == null) {
          navigation.navigate('MainMenu')
          navigation.navigate('NewGame')
        }
        if(value !== undefined) dataReceived(value)
      })
    }
    readValue()

    checkAppVersionOnline();

  return (
    <View style={{ flex: 1, flexDirection: 'column' }}>
      <View style={{ flex: 1 }}>
        <View style={{ marginBottom: 'auto', marginTop: 'auto', marginLeft: 'auto', marginRight: 'auto' }}>
          <Image
            style={{ width: 200, height: 134 }}
            source={require('./../img/mainImage.png')}
          />
        </View>
      </View>
      <View style={{ flex: 2 }}>
        <ScrollView>
          <View style={{ marginHorizontal: 25, marginBottom: 'auto' }}>
            <View>
              <View style={[GlobalStyles.buttonMargins]}>
                <Pressable
                  style={GlobalStyles.buttonMain}
                  onPress={() => {
                    //if(checkLesiones(value,true) != "") alert("ALERTA","Alguno de tus titulares está lesionado, puedes jugar el partido, pero será inmediatamente sustituido por un FAN RANDOM",[{text: "OK", onPress: () => void(0), style: "cancel"}])
                    checkingInjury(value, navigation)
                  }
                  }>
                  <Text style={GlobalStyles.textForButtonMain}>{transl('HomeScreen.siguientePartido', lang)}</Text>
                </Pressable>
              </View>
              <View style={[GlobalStyles.buttonMargins]}>
                <Pressable
                  style={GlobalStyles.buttonMain}
                  onPress={() => navigation.navigate('Roster')}>
                  <Text style={GlobalStyles.textForButtonMain}>{transl('HomeScreen.plantilla', lang)}</Text>
                </Pressable>
              </View>
              <View style={[GlobalStyles.buttonMargins]}>
                <Pressable
                  style={GlobalStyles.buttonMain}
                  onPress={() => navigation.navigate('ComparePlayers')}>
                  <Text style={GlobalStyles.textForButtonMain}>{transl('HomeScreen.compararJugadores', lang)}</Text>
                </Pressable>
              </View>
              <View style={[GlobalStyles.buttonMargins]}>
                <Pressable
                  style={GlobalStyles.buttonMain}
                  onPress={() => navigation.navigate('ListOfButtons', { btn: [[transl('General.liga', lang), 'Clasification'], [transl('General.mejoresJugadores',lang),'BestPlayers'], [transl('General.losersCup', lang), 'CupInfo', 'losersCup'], [transl('General.spanishCup', lang), 'CupInfo', 'spanishCup'], [transl('General.europeanCup', lang), 'CupInfo', 'europeanCup'], [transl('General.worldCup', lang), 'CupInfo', 'worldCup'], [transl('General.superCup', lang), 'CupInfo', 'superCup'], [transl('MainMenu.salon', lang), 'HallOfFame']], name: transl('MainMenu.clasificacion', lang) })}>
                  <Text style={GlobalStyles.textForButtonMain}>{transl('HomeScreen.clasificacion', lang)}</Text>
                </Pressable>
              </View>
              <View style={[GlobalStyles.buttonMargins]}>
                <Pressable
                  style={GlobalStyles.buttonMain}
                  onPress={() => navigation.navigate('Market')}>
                  <Text style={GlobalStyles.textForButtonMain}>{transl('HomeScreen.mercado', lang)}</Text>
                </Pressable>
              </View>
              <View style={[GlobalStyles.buttonMargins]}>
                <Pressable
                  style={GlobalStyles.buttonMain}
                  onPress={() => navigation.navigate('ListOfButtons', { btn: [[transl('MainMenu.importarAmigo', lang), 'DownloadTeam'], [transl('MainMenu.enviarAmigo', lang), 'SendTeam'], [transl('MainMenu.lista', lang), 'FriendsList']], name: transl('HomeScreen.amigos', lang) })}>
                  <Text style={GlobalStyles.textForButtonMain}>{transl('HomeScreen.amigos', lang)}</Text>
                </Pressable>
              </View>
              <View style={[GlobalStyles.buttonMargins]}>
                <Pressable
                  //disabled={true}
                  style={GlobalStyles.buttonMain}
                  onPress={() => navigation.navigate('Objects')}>
                  <Text style={GlobalStyles.textForButtonMain}>{transl('HomeScreen.objetos', lang)}</Text>
                </Pressable>
              </View>
              <View style={[GlobalStyles.buttonMargins]}>
                <Pressable
                  //disabled={true}
                  style={GlobalStyles.buttonMain}
                  onPress={() => navigation.navigate('Tactics')}>
                  <Text style={GlobalStyles.textForButtonMain}>Tácticas</Text>
                </Pressable>
              </View>
              <View style={[GlobalStyles.buttonMargins]}>
                <Pressable
                  disabled={true}
                  style={GlobalStyles.buttonMainDisabled}
                  onPress={() => navigation.navigate('ForgeBroom')}>
                  <Text style={GlobalStyles.textForButtonMainDisabled}>Forjar Escoba</Text>
                </Pressable>
              </View>
              <View style={[GlobalStyles.buttonMargins]}>
                <Pressable
                  disabled={true}
                  style={GlobalStyles.buttonMainDisabled}
                  onPress={() => navigation.navigate('ChangeNamePlayers')}>
                  <Text style={GlobalStyles.textForButtonMainDisabled}>Cambiar nombre jugadores</Text>
                </Pressable>
              </View>
              <View style={[GlobalStyles.buttonMargins]}>
                <Pressable
                  style={GlobalStyles.buttonMainDisabled}
                  onPress={() => navigation.navigate('Online')}>
                  <Text style={GlobalStyles.textForButtonMainDisabled}>Online</Text>
                </Pressable>
              </View>
              <View style={[GlobalStyles.buttonMargins]}>
                <Pressable
                  style={GlobalStyles.buttonMain}
                  onPress={() => navigation.navigate('ListOfButtons', { btn: [[transl('MainMenu.ayuda', lang), 'Help'], [transl('MainMenu.perfil', lang), 'Profile'], [transl('MainMenu.configuracion', lang), 'Configuration'], [transl('MainMenu.opcionesPara', lang), 'Special']], name: transl('HomeScreen.opciones', lang) })}>
                  <Text style={GlobalStyles.textForButtonMain}>{transl('HomeScreen.opciones', lang)}</Text>
                </Pressable>
              </View>
            </View>
          </View>
        </ScrollView>
      </View>
    </View>
  )
}

function checkingInjury(data,nav){
  if(data === undefined || !data) return false
  if(typeof data != "object") data = data != null ? JSON.parse(data) : null

  const lesiones = checkLesiones(data,true)
  
  if(lesiones == "" || !data.settings.informInjuries) {
    alertDisparadorDePartidos(data,nav);
    return
  }

  alert(transl('HomeScreen.lesiones', lang),transl('HomeScreen.tienesEstosJug', lang,[lesiones.map((player)=>player.name)]),[
    {text:transl('HomeScreen.plantilla', lang),onPress:()=>{nav.navigate('Roster')}},
    {text:transl('General.OK', lang),style:"cancel",onPress:()=>{alertDisparadorDePartidos(data,nav)}},
    {text:transl('HomeScreen.cambiosAutomaticos', lang),onPress:()=>{automaticChanges(data,nav,lesiones)}}
  ])
  return false
}

function automaticChanges (data,nav,lesiones) {
  for(let k = 0; k < lesiones.length; k++){
    for (let i = 7; i < data.teams[0].players.length; i++) {
      if (data.teams[0].players[i].injury > 0) continue

      const firstChange = Object.assign({}, data.teams[0].players[i]);
      data.teams[0].players[i] = data.teams[0].players[lesiones[k].index]
      data.teams[0].players[lesiones[k].index] = firstChange;
      break
    }
  }
  saveData(data)
  
  alertDisparadorDePartidos(data,nav)
}

function alertDisparadorDePartidos(data,nav){
  alert(transl('HomeScreen.empezar', lang), dataReceived(data), [
    {text: transl('General.No', lang), onPress: () => void(0), style: "cancel"},
    {text: transl('General.Si', lang), onPress: () => nav.navigate('NextMatch',nextGameInfo)}
  ])
}

function dataReceived(data) {
  if(data === undefined || !data) return
  if(typeof data != "object") data = data != null ? JSON.parse(data) : null

  //comprobamos primero si hay algún jugador lesionado
  
  let myTeamEnemy = data.others.siguientePartido

  //si hay liga, pasamos liga y se juega eso (else), si no jugamos la copa que toque
  const cp = data.others.championships;
  let jornadaReal = data.others.siguientePartido
  if(data.others.vecesTodosLosPartidosHechos%2) jornadaReal += 19
  let tipoDePartido = transl('General.liga', lang)

  if(checkIfIPlayCup(cp.losersCup,jornadaReal)){
    nextGameInfo = {name:'losersCup'}
    let indicesDeLosGanadores = ttptr(cp.losersCup)
    tipoDePartido = transl('General.losersCup', lang)+" "+dr.tiposDeCopa[Math.log2(indicesDeLosGanadores.length)-1]+" ("+((cp.losersCup.currentRound % (cp.losersCup.gamesPerRound)) + 1)+"/"+cp.losersCup.gamesPerRound+")"
    myTeamEnemy = cp.losersCup.equipos[indicesDeLosGanadores[1]].id - 1
  } else if (checkIfIPlayCup(cp.spanishCup,jornadaReal)) {
    nextGameInfo = {name:'spanishCup'}
    let indicesDeLosGanadores = ttptr(cp.spanishCup)
    tipoDePartido = transl('General.spanishCup', lang)+" "+dr.tiposDeCopa[Math.log2(indicesDeLosGanadores.length)-1]+" ("+((cp.spanishCup.currentRound % (cp.spanishCup.gamesPerRound)) + 1)+"/"+cp.spanishCup.gamesPerRound+")"
    myTeamEnemy = cp.spanishCup.equipos[indicesDeLosGanadores[1]].id - 1
  } else if (checkIfIPlayCup(cp.europeanCup,jornadaReal)) {
    nextGameInfo = {name:'europeanCup'}
    let indicesDeLosGanadores = ttptr(cp.europeanCup)
    tipoDePartido = transl('General.europeanCup', lang)+" "+dr.tiposDeCopa[Math.log2(indicesDeLosGanadores.length)-1]+" ("+((cp.europeanCup.currentRound % (cp.europeanCup.gamesPerRound)) + 1)+"/"+cp.europeanCup.gamesPerRound+")"
    myTeamEnemy = cp.europeanCup.equipos[indicesDeLosGanadores[1]].id - 1
  } else if (checkIfIPlayCup(cp.worldCup,jornadaReal)) {
    nextGameInfo = {name:'worldCup'}
    let indicesDeLosGanadores = ttptr(cp.worldCup)
    tipoDePartido = transl('General.worldCup', lang)+" "+dr.tiposDeCopa[Math.log2(indicesDeLosGanadores.length)-1]+" ("+((cp.worldCup.currentRound % (cp.worldCup.gamesPerRound)) + 1)+"/"+cp.worldCup.gamesPerRound+")"
    myTeamEnemy =cp.worldCup.equipos[indicesDeLosGanadores[1]].id - 1
  } else if (checkIfIPlayCup(cp.superCup,jornadaReal)) {
    nextGameInfo = {name:'superCup'}
    let indicesDeLosGanadores = ttptr(cp.superCup)
    tipoDePartido = transl('General.superCup', lang)+" "+dr.tiposDeCopa[Math.log2(indicesDeLosGanadores.length)-1]+" ("+((cp.superCup.currentRound % (cp.superCup.gamesPerRound)) + 1)+"/"+cp.superCup.gamesPerRound+")"
    myTeamEnemy = cp.superCup.equipos[indicesDeLosGanadores[1]].id - 1
  } else {
    //si entra aqui es que es partido de liga
    nextGameInfo = {name:'liga'}
    if(myTeamEnemy > 10) myTeamEnemy = -(myTeamEnemy - 11)
    myTeamEnemy = myTeamEnemy + 9
  }

  return transl('HomeScreen.jornada', lang,[jornadaReal,tipoDePartido,data.teams[myTeamEnemy].name])
}

function checkIfIPlayCup(cup,jornadaReal) {
  if(jornadaReal == cup.rondas[cup.currentRound]){
    //es jornada de partido
    if(cup.equipos[0].id == 1) {
      //mi equipo está en la copa
      let indicesEnCopa = ttptr(cup)
      if(cup.equipos[indicesEnCopa[0]].id == 1) {
        //mi equipo esta entre los que han sobrevivido
        return true
      }
    }
  }
  return false
}

function saveData(data){
  const storeData = async (data) => {
    try {
      const jsonValue = JSON.stringify(data)
      await AsyncStorage.setItem('equipos', jsonValue)
    } catch (e) {
      console.log("error saving file")
      console.log(e)
    }
  }

  storeData(data);
}

function checkAppVersionOnline () {
  const [data, setData] = useState(null);
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    // Use an async function to fetch the data
    const fetchData = async () => {
      try {
        const response = await fetch('https://quedepp.santitorrabadella.com/status.json');
        const json = await response.json();
        setData(json); // Set the fetched data in the state
        setIsLoading(false); // Set isLoading to false when data is fetched
      } catch (error) {
        console.error(error);
      }
    };
  
    fetchData(); // Call the fetchData function when the component mounts
  }, []);

  if (data && !urlUpdateOpened) {
    urlUpdateOpened = true;
    //todo (checkear version de la app para comprobar online https://github.com/APSL/react-native-version-number#manual-installation)
    console.log(VersionNumber)
    /*if (data.info.stableVersion !== globalInfo().stableVersion) {
      alert("Actualización", "Tienes que actualizar la versión de la aplicacion.",[
        {text:"Actualizar",onPress: async () => {
          const url = "https://quedepp.santitorrabadella.com/"
          const supported = await Linking.canOpenURL(url);

          if (supported) {
            await Linking.openURL(url);
            console.log("abierto con exito");
          }
        }, style: "cancel"},
        {text:"Más tarde",style:"cancel",onPress:()=>{undefined}}
      ])
    }*/
  }
}

const OpenURLButton = ({ url, children }) => {
  const handlePress = useCallback(async () => {
    console.log("enters in handlepress");
    const supported = await Linking.canOpenURL(url);

    if (supported) {
      await Linking.openURL(url);
      console.log("abierto con exito");
    } else {
      console.log(`Don't know how to open this URL: ${url}`);
    }
  }, [url]);

  return (
    <TouchableOpacity onPress={handlePress}>
      {/* You can render any children here */}
      {children}
    </TouchableOpacity>
  );
};

export default HomeScreen